import config from '../nyConfig'
const ApiPublic = {
    "显示图片": new config({url: '/image/show', showSuccessMessage: true, useToken: false }),
    "显示视频": new config({url: '/video/play', showSuccessMessage: true, useToken: true }),
    "上传图片": new config({url: '/resource/uploadResource', showSuccessMessage: true, useToken: false }),
    "上传视频": new config({url: '/resource/uploadVideo', showSuccessMessage: true, useToken: false }),
    "上传文件": new config({url: '/resource/uploadResource', showSuccessMessage: true, useToken: false }),
}

export default ApiPublic
